import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';

@Injectable()
export class ExportManagerService extends BaseHttpService {

  public fetch(brandId: string, page: number, itemsPerPage: number): Observable<any> {
    return this.http.get(
      Config.API +
      '/parts-exports/' + brandId +
      '?page=' + page + '&itemsPerPage=' + itemsPerPage
    )

    .pipe(catchError(this.handleError.bind(this)));
  }

  public getCompleted(brandId: string, fileIds: Array<string>, receiverDataIds: Array<string>): Observable<any> {
    const body = JSON.stringify({ fileIds, receiverDataIds });
    return this.http.post(
      `${Config.API}/exports/${brandId}/completed-files-and-receivers`,
      body,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  public postResend(brandId: string, receiverDataId: string): Observable<any> {
    const body = JSON.stringify({ receiverDataId });

    return this.http.post(
      `${Config.API}/exports/${brandId}/resend`,
      body,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  public getExportsForReceiver(brandId: string, receiverId: string): Observable<any> {
    return this.http.get(
      `${Config.API}/exports/${brandId}?page=1&itemsPerPage=50&receiverId=${receiverId}`,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  public getExportTypes(brandId: string|number): Observable<any> {
    return this.http.get(
      `${Config.API}/exports/${brandId}/types`,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }
}
